import { createI18n } from 'vue-i18n'

import gb from './locales/gb.json'
import tw from './locales/tw.json'

const messages = {
  gb,
  tw,
}

export default createI18n({
  legacy: false,
  locale: 'tw',
  fallbackLocale: 'gb',
  messages,
})
